var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"d-block text-center",attrs:{"to":{ path: '/' }}},[_c('b-img',{attrs:{"src":require("@/assets/images/lv_logo_w.png"),"alt":"LV"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }